export const acsConfig = {
    endpoint: "https://communicationserviceorigin.communication.azure.com"
}